import { calculateBasketCount } from "../utils"
import { useBasket } from "./useBasket"

export function useBasketCount(): number {
  const basket = useBasket()
  return calculateBasketCount(basket)
}
